import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface CapacityProps {
  band: Band
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const Capacity: React.FC<CapacityProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    return (await handleUpdateBandData(band.id, {
      additional_info: {
        capacity: data.additional_info?.capacity || null,
      },
    })) as ApiResponse
  }

  const fieldData = {
    field: "additional_info.capacity",
    name: "capacity",
    label: "Capacity",
    placeholder: "Enter venue capacity",
    required: false,
  }

  return (
    <EditBandFormField
      type="number"
      fieldData={fieldData}
      bandId={band.id}
      onSubmit={customOnSubmit}
    />
  )
}
